module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg dropdown-toggle",
    attrs: {
      "id": "btn-offer",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n    Sprawdź już teraz\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "btn-offer"
    }
  }, [_c('a', {
    staticClass: "dropdown-item text-uppercase",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Oferta indywidualna")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item text-uppercase",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Oferta biznesowa")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d0e102a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing/components/OfferButton.vue
// module id = 45
// module chunks = 0